/**
 * @voltxampere/ui — TL431 adjustable shunt regulator variant (Sprint 42-3)
 *
 * V_REF = 2.495 V internal; user sets V_KATHODE = V_REF × (1 + R1/R2)
 * via external divider. Sprint 42 ships at the 2.5 V default
 * setpoint; runtime R-binding (sense R1/R2 to recompute V_KATHODE)
 * lands Sprint 43+ scope.
 *
 * Reference: TI TL431. Engine zero-diff via canonical
 * "voltage-source".
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const referenceTl431 = {
    id: "tl431",
    nameTr: "TL431 (Ayarlanabilir Şönt Regülatör, TO-92)",
    nameEn: "TL431 (Adjustable Shunt Regulator, TO-92)",
    shortcut: "V",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "TL431",
    schemaType: "voltage-source",
    defaultParams: { voltage: 2.5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=reference-tl431.js.map